export default {
  'user.Home': '主页',
  'user.Me': '我',
  'user.Name': '姓名',
  'user.Message': '消息',
  'user.View all message': '查看所有消息',
  'user.Learning Resource': '学习资源',
  'user.Toolkit For Employee': '潜力狮参考资料',
  'user.Privacy Notice': '隐私声明',
  'user.Log out': '退出登录',
  'user.Young Talent Career Guide and Learning Resources':
    '潜力狮职业发展指南及学习资源',
  'user.My Application': '我的申请',
  'user.Apply For ROAR Moment': '申请出狮',
  'user.Your are not in the eligible scope of this round.':
    '您不在本轮出狮行动的可申请范围内',
  'user.Welcome to Project ROAR': '欢迎来到出狮行动线上平台',
  'user.Publicis Commitment': '阳狮集团致力于支持我们充满激情、创造价值的青年人才，从大家的职业早期开始。在这一承诺下，集团打造了出狮行动，为青年潜力狮提供一个展示自我、加速发展的舞台。',
  'user.Platform Description': '在这一平台中，您可以查看集团对不同角色职位的能力要求以及配套提供的学习资源。掌控自己的职业发展，就是现在！',
  'user.Offline Mode Is On': '当前为线下流程',
  'user.Latest Update': '最新通知',
  'user.The Project ROAR open window is closed.': '本轮出狮行动已关闭申请。',
  'user.Back': '返回',
  'user.Notification': '通知',
  'user.Messages': '消息',
  'user.Delete All': '全部删除',
  'user.Are you sure delete all selected messages?': '确定删除所有选中的消息？',
  'user.Cancel': '取消',
  'user.OK': '确认',
  'user.Date': '日期',
  'user.Action': '操作',
  'user.Young Talent Career Guide and Learning Resource':
    '潜力狮职业发展指南及学习资源',
  'user.Role:': '角色：',
  'user.Role': '角色',
  'user.Brand': '品牌',
  'user.Level': '级别',
  'user.The highlighted items show the key difference between this level and one level down.':
    '金色高亮显示的项目为当前所选职级要求与低一职级能力要求之间的主要差别。',
  'user.Job Qualifications': '能力要求',
  'user.Please select role to see job qualification list.':
    '请选择角色职级，查看能力要求',
  'user.Learning Resources': '学习资源',
  'user.You can click on the link to enroll directly. For course without link, please contact your HRBP for nomination.':
    '您可以点击链接直接报名课程。',
  'user.If you have any questions about learning, please contact':
    '如果关于学习资源部份您有任何问题，请联系',
  'user.Please select role to see learning resources.': '请选择职位以查看学习资源',
  'user.Title': '职位',
  'user.Review Manager': '狮厂经理',
  'user.Delete': '删除',
  'user.Are you sure delete this message?': '确定删除此消息？',
  'user.Application Season': '申请季度',
  'user.Current Role': '当前角色职级',
  'user.Target Role': '目标角色职级',
  'user.Learning': '学习课程',
  'user.Mandatory': '必修课程',
  'user.Employee': '潜力狮',
  'user.No Comments': '无评语',
  'user.View Comments': '查看评语',
  'user.Current Role Job Qualifications': '当前角色职级的能力要求',
  'user.Qualified': '符合要求',
  'user.Comments': '评语',
  'user.Check the status of your application': '查看您的申请状态',
  'user.Application Due Date': '申请截止日期',
  'user.Application Date': '申请日期',
  'user.Details': '详情',
  'user.Panel Result': '出狮结果',
  'user.View': '查看',
  'user.Pending': '待审批',
  'user.Approve for Panel': '同意进入管理层评估',
  'user.Disapprove for Panel': '不同意进入管理层评估',
  'user.Reopen': '重启',
  'user.Your applicatinon is waiting for your review manager’s approval.':
    '您的申请正在等待您的狮厂经理的审批',
  'user.Your panel review applicatinon has been appproved.':
    '您的申请已被批准，您可进入管理层评估。',
  "user.Your panel review application is not approved. Please click details to view your leader's assessment and comments":
    '您的申请未被批准。请点击详情，查看狮厂经理给您的详细评估意见。',
  'user.Your application is reopened. Please reapply.':
    '您的申请已重启，请重新提交申请',
  'user.No Application': '未申请',
  'user.Promotion': '晋升',
  'user.Salary Adjustment': '调薪',
  'user.Transfer': '转岗',
  'user.Try Again Next Time': '请您下次再尝试',
  'user.No show': '未参加',
  'user.No Participation': '未参加',
  'user.No Participation_Not Win': '未参加/未成功',
  'user.Resigned': '已离职',
  'user.My Team': '我的团队',
  'user.Application Start Date': '申请开始日期',
  'user.Application Approval Period': '申请审批阶段',
  'user.Toolkit For Review Manager': '狮厂经理参考资料',
  'user.Select your current role': '选择您当前的角色职级',
  'user.Check job qualifications and leave comments':
    '查看当前角色职级的要求并进行自评',
  'user.Proceed to next step': '进入下一步',
  'user.Please select your current role to see job qualification list.':
    '请选择您的职位，以查看工作任职资格表',
  'user.Theme': '主题',
  'user.Next': '下一步',
  'user.Check the box if you meet the qualification.':
    '如果您符合职位要求，请勾选方框',
  'user.√ and × are marked based on the valid record of your training completion. If the mandatory courses and tests are not all completed (marked as ×), you would not be able to submit the application. If you have any question, please contact':
    '√和×是根据您完成课程的有效记录来标记的。如您未完成全部必修课程及其考试（标记为×），则将无法进行出狮申请。如有关于学习课程的问题，请联系',
  'user.Please leave comments on the qualification boxes which are not checked.':
    '请在未勾选的岗位要求旁留下评语',
  'user.Optional': '选修课程',
  'user.Learning Record': '学习记录',
  'user.Leave Comments': '留下评语',
  'user.your previous choice will be override, are you sure?':
    '您之前的选择将被清空，确定这样做吗？',
  'user.Please write your comments': '请填写您的评语',
  'user.Done': '确认',
  'user.Important Date': '重要日期',
  'user.Group List': '管理名单',
  'user.ROAR Application HRBP Review Due Date': '本轮出狮行动HRBP审查截止日期',
  'user.Panel Result Submission Due Date': '出狮结果上传截止日期',
  'user.Please review the status of application, remind leaders for pending cases and reopen assessment if needed before the due date. System will automatically publish application status to the employee after this due date.':
    '请审查申请状态，提醒狮厂经理处理待审批的申请，如有需要，可在HRBP审查截止日期前使用重启功能。系统将在该日期的后一天自动向潜力狮发布狮厂经理评估结果。',
  'user.After getting global confirmation, please upload the panel result and comments before the due date. TMOD will publish the result to all before payroll cut-off date.':
    '在得到集团总部确认后，请在截止日期前上传出狮结果和评语。TMOD将会在工资发放日前发布。',
  'user.Toolkit For HRBP': 'HRBP参考资料',
  'user.Review the application status': '查看申请状态',
  'user.View the details if needed': '如有需要，请查看详情',
  'user.If the application does not meet the requirements, please reopen':
    '如果申请不符合要求，请重启',
  'user.Ensure that all status have been reviewed by the review manager':
    '确保狮厂经理审批了全部申请',
  'user.View Group List': '查看管理名单',
  'user.Export to Excel': '导出Excel',
  'user.Upload': '上传',
  'user.Number of Total Talents': '人才库总数',
  'user.Number of Applicants': '申请人数',
  'user.Employee / Review Manager': '潜力狮 / 狮厂经理',
  'user.Download assessment': '下载评估报告',
  'user.Reopen Review Manager': '仅重启狮厂经理评估',
  'user.Reopen Both': '同时重启潜力狮申请及狮厂经理评估',
  "user.The application is waiting for review manager's approval.":
    '此申请正在等待狮厂经理的审批',
  'user.The panel review application has been approved.':
    '狮厂经理已审批，同意进入管理层评估环节',
  'user.The panel review application is not approved.':
    '狮厂经理已审批，未同意进入管理层评估环节',
  "user.The talent's application is reopened.": '潜力狮的申请被重启',
  'user.Status': '状态',
  'user.Current Brand': '当前所属品牌',
  'user.Download employee application records': '下载潜力狮申请记录',
  'user.View assesement from employee and review manager. Panel result and comments will also be displayed here after you upload the data.':
    '查看潜力狮和评审经理的评估。在您上传数据后，评审结果和意见也将显示在这里',
  'user.Assessment Result': '评估结果',
  'user.HRBP': 'HRBP',
  'user.Submitted Successfully': '提交成功',
  'user.your application has been submitted successfully!':
    '您的申请已经成功提交！',
  'user.Please wait for response and feedback from your review manager.':
    '请等待狮厂经理的评估反馈',
  'user.View My Application': '查看我的申请',
  'user.Back to Home': '返回主页',
  'user.My Team Applications': '我的团队申请',
  'user.Application Approval Due Date': '申请审批截止日期',
  'user.Eligible Applicant': '可申请潜力狮',
  'user.Applied Applicant': '已申请潜力狮',
  'user.Check the status of your team members’ applications. Review and evaluate the applications of your team members.':
    '查看您团队成员的申请状态。审查并评估您团队成员的申请',
  'user.The application is waiting for your approval.':
    '此申请正在等待您的审批',
  'user.The panel review application is not approved. Please have a career dialog with your team member.':
    '申请未批准，请和您的潜力狮进行职业对话',
  "user.Your team member's application is reopened. Please wait for your team member to reapply.":
    '潜力狮的申请已被重启，请等待潜力狮重新提交申请.',
  'user.Review and Evaluate': '审查与评估',
  'user.Download Assessment': '下载评估报告',
  'user.Please click to choose which type of assessment you want. Once the file is ready, a download link will be sent to your Publicis mailbox':
    '请选择您想要下载的评估文档类型。一旦文件准备好，下载链接将会发送到您的阳狮集团内部邮箱',
  'user.Download latest assessment': '下载当期评估报告',
  'user.Download all assessment': '下载历期评估报告（含当期）',
  'user.View assessment and comments from your employee': '查看潜力狮自评',
  "user.Assess your employee's qualification of his/her current role":
    '对潜力狮当前角色职级所要求的能力进行评估',
  'user.Submit the assessment': '提交评估',
  'user.View My Team': '查看我的团队',
  'user.√ and × are marked based on the valid record of training attendance. Talent who submitted the ROAR application has completed all the mandatory courses. You can also share your comments on the learning part.':
    '√和×是根据有效的培训完成情况来标记的，能够提交出狮申请的潜力狮已完成全部必修课程。您也可以在学习这部分分享您的意见。',
  'user.Panel Comments': '管理层评语',
  'user.Assess your employee and leave comments': '请评估您的潜力狮并留下评语',
  'user.Message deleted': '此消息已删除',
  'user.Select your target role': '选择您的目标角色职级',
  'user.Review job qualification as reference for your future development':
    '查看目标角色职级的要求作为未来发展的参考',
  'user.Submit the application': '提交申请',
  'user.Please select your target role to see job qualification list':
    '请选择您的目标职位以查看对应的能力要求',
  'user.Submit': '提交',
  'user.Submit Information': '提交信息',
  'user.Are you sure you want to submit this application now?':
    '确定提交申请？',
  'user.Yes': '是',
  'user.No': '否',
  'user.Are you sure you want to leave the page? The information will be saved after you leave the page':
    '您确定要离开这个页面吗？离开后，已填信息将被保存',
  'user.Please select your target role to see learning resources.':
    '请选择您的目标职位以查看对应的学习课程',
  "user.You don't have application yet": '您没有申请记录',
  'user.You have successfully submitted your assessment':
    '您已经成功提交了您的评估',
  'user.You have disapproved this employee for panel review，Are you sure you want to proceed?':
    '您不同意潜力狮的申请，不批准潜力狮进入管理层评估。您确定要继续吗？',
  'user.You have approved this employee for panel review. Are you sure you want to proceed?':
    '您同意潜力狮的申请，批准潜力狮进入管理层评估。您确定要继续吗？',
  'user.Edit': '编辑',
  'user.Selected': '已选择',
  'user.items': '项',
  'user.Your request has been received': '您的请求已收到',
  'user.Are you sure you want to reopen review manager’s assessment?':
    '您确定需要重启狮厂经理的评估吗？',
  'user.Are you sure you want to reopen review manager’s assessment and employee’s application?':
    '您确定需要重启潜力狮的申请及狮厂经理的评估吗？',
  'user.Reopen Application': '重启申请',
  'user.Back to The Previous Page': '返回上一页',
  'user.No Data': '暂无数据',
  'user.This Session is Offline': '本轮无线上申请流程',
}
